/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const AppRegistrationMessages = defineMessages({
  title: {
    id: 'MicrosoftTeams.AppRegistrationMessages.title',
    defaultMessage: 'Create an app registration on Teams'
  },
  descriptionOne: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionOne',
    defaultMessage:
      'Go to <link>Microsoft Azure</link> and log in with your credentials.'
  },
  descriptionTwo: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionTwo',
    defaultMessage:
      'On the App registrations page, click <strong>New registration</strong>. Choose a name, select the tenancy option under <strong>Supported account types</strong> that best applies to your application, then click <strong>Register</strong>.'
  },
  descriptionThree: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionThree',
    defaultMessage: 'Copy the Application (client) ID and paste it here:'
  },
  descriptionSix: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionSix',
    defaultMessage:
      'If the application registration is Single tenant, copy the Directory (tenant) ID and paste it here, otherwise leave it blank:'
  },
  appRegistration: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appRegistration',
    defaultMessage: 'App registration'
  },
  appId: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appId',
    defaultMessage: 'Application (client) ID'
  },
  tenantId: {
    id: 'MicrosoftTeams.AppRegistrationMessages.tenantId',
    defaultMessage: 'Tenant ID'
  },
  appIdPlaceholder: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appIdPlaceholder',
    defaultMessage: 'Enter application (client) ID'
  },
  tenantIdPlaceholder: {
    id: 'MicrosoftTeams.AppRegistrationMessages.tenantIdPlaceholder',
    defaultMessage: 'Enter tenant ID'
  },
  appIdRequired: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appIdRequired',
    defaultMessage: 'Application (client) ID is required'
  },
  nonEmptyAppId: {
    id: 'MicrosoftTeams.AppRegistrationMessages.nonEmptyAppId',
    defaultMessage: 'Application (client) ID cannot be empty'
  },
  descriptionFour: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionFour',
    defaultMessage:
      'Click {addCertificateOrSecret} to navigate to token creation. Click {newClientSecret}. Complete the form with the recommended 180-day expiration date, or whichever selection best fits your use case, then click {add}. Update your expiration date selection below.'
  },
  clientSecret: {
    id: 'MicrosoftTeams.AppRegistrationMessages.clientSecret',
    defaultMessage: 'Client secret'
  },
  newClientSecret: {
    id: 'MicrosoftTeams.AppRegistrationMessages.newClientSecret',
    defaultMessage: 'New client secret'
  },
  addCertificateOrSecret: {
    id: 'MicrosoftTeams.AppRegistrationMessages.addCertificateOrSecret',
    defaultMessage: 'Add a certificate or secret'
  },
  add: {
    id: 'MicrosoftTeams.AppRegistrationMessages.add',
    defaultMessage: 'Add'
  },
  descriptionFive: {
    id: 'MicrosoftTeams.AppRegistrationMessages.descriptionFive',
    defaultMessage:
      'Copy the string under the {value} section of the table and paste it here:'
  },
  value: {
    id: 'MicrosoftTeams.AppRegistrationMessages.value',
    defaultMessage: 'value'
  },
  appPasswordPlaceholder: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appPasswordPlaceholder',
    defaultMessage: 'Enter client secret value'
  },
  appPasswordRequired: {
    id: 'MicrosoftTeams.AppRegistrationMessages.appPasswordRequired',
    defaultMessage: 'Client secret value is required'
  },
  nonEmptyAppPassword: {
    id: 'MicrosoftTeams.AppRegistrationMessages.nonEmptyAppPassword',
    defaultMessage: 'Client secret value cannot be empty'
  },
  expirationNote: {
    id: 'MicrosoftTeams.AppRegistrationMessages.expirationNote',
    defaultMessage:
      'Make sure you add a new client secret before the current one expires.'
  }
});
